import React from "react";
import { Box, Button } from "@mui/material";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

const MaintenancePage = ({ title, message, onRetry, retrying }) => {
  const heading = title || "Service Unavailable.";
  const body =
    message || "Please contact your system administrator.";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(160deg, #152456 0%, #28326f 55%, #1a3a8a 100%)",
        px: 2,
        py: 4,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 520,
          bgcolor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 24px 60px rgba(15, 23, 42, 0.35)",
          p: { xs: 3, sm: 4 },
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            mx: "auto",
            mb: 2.5,
            borderRadius: "50%",
            bgcolor: "#eff6ff",
            color: "#28326f",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <BuildOutlinedIcon sx={{ fontSize: 36 }} />
        </Box>
        <Box sx={{ fontSize: 22, fontWeight: 700, color: "#28326f", mb: 1.5 }}>
          {heading}
        </Box>
        <Box sx={{ fontSize: 14, color: "#4b5563", lineHeight: 1.6, mb: 3 }}>
          {body}
        </Box>
        <Button
          variant="contained"
          onClick={onRetry}
          disabled={retrying}
          sx={{
            bgcolor: "#28326f",
            "&:hover": { bgcolor: "#1e2554" },
            textTransform: "none",
            fontWeight: 600,
            px: 3,
          }}
        >
          {retrying ? "Checking..." : "Retry"}
        </Button>
      </Box>
    </Box>
  );
};

export default MaintenancePage;
